export default "__VITE_ASSET__CLwCL1M$__"